import React, { useCallback } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import { IconEdit } from 'design-system/icons/IconEdit';
import { SettingsItem, SettingsItemRightContent, } from 'design-system/SettingsItem';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import IconTransactionCategory from 'features/transactions/icons/IconTransactionCategory';
const EditCategoryListVerticalRow = ({ category, description, isDefaultCategory, showEdit, onPress, }) => {
    const styles = useStyles(styleSet);
    const renderIcon = useCallback(() => (<View style={styles.imageBadgeWrapper}>
        <View style={styles.imageContainer}>
          <IconTransactionCategory width={rem(24)} height={rem(24)} category={category}/>
        </View>
      </View>), [category, styles.imageBadgeWrapper, styles.imageContainer]);
    const press = useCallback(() => {
        onPress?.(category, Boolean(isDefaultCategory));
    }, [category, isDefaultCategory, onPress]);
    return (<SettingsItem title={category.displayName} description={description} renderIcon={renderIcon} onPress={press}>
      <SettingsItemRightContent>
        {showEdit ? <IconEdit colorKey="secondary"/> : null}
      </SettingsItemRightContent>
    </SettingsItem>);
};
const styleSet = createStyleSheets((colors) => ({
    category: {
        paddingVertical: rem(24),
    },
    categoryContent: {
        alignItems: 'center',
    },
    imageBadgeWrapper: {
        width: rem(44),
        marginRight: rem(16),
    },
    imageContainer: {
        height: rem(44),
        width: rem(44),
        borderRadius: rem(28),
        backgroundColor: colors.background.dark,
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        height: rem(44),
        width: rem(44),
        borderRadius: rem(28),
        justifyContent: 'center',
        alignItems: 'center',
    },
}));
export default EditCategoryListVerticalRow;
